import { useEffect } from 'react'

import { useCreateUsdtDepositAddressMutation, useGetUsdtAddressQuery, useWatchDepositsMutation } from '../../../features/quick-sell/quickSellSlice'
import { useGetUsdtRateQuery, useGetCoinTrendQuery } from '../../../features/trade&coins/bitcoinSlice'
import { useGetAllCoins24hChangesQuery } from '../../../features/trade&coins/coinsChangesSlice'
import Card from './SellBitcoin'


export const SellUsdt = () => {

  const { data: usdtRate } = useGetUsdtRateQuery()

  // Fetch trend data for USDT
  const { data: trendData, isLoading: isTrendLoading } = useGetCoinTrendQuery('usdt', {
    refetchOnMountOrArgChange: true,
  });

  // Use bulk query and extract USDT data
  const { data: allCoinsChanges, isLoading: isChangeLoading } = useGetAllCoins24hChangesQuery();
  const coinChange = allCoinsChanges?.['usdt'];

  const { data, isLoading } = useGetUsdtAddressQuery();

  const [createAddress, { isLoading: isCreateDepositLoading, isSuccess: isCreateSuccess }] = useCreateUsdtDepositAddressMutation()

  const [watch] = useWatchDepositsMutation();

  useEffect(() => {
    watch({}).unwrap();
  }, []);

  useEffect(() => {
    watch({}).unwrap();
  }, [isCreateSuccess]);


  return (
    <div className="space-y-8">
      <Card 
        coin="usdt" 
        paymentAddress={data?.address} 
        onGenerateAddress={() => { createAddress({}) }} 
        isLoading={isCreateDepositLoading} 
        loadingData={isLoading} 
        rate={usdtRate} 
        coinChange={coinChange}
        isChangeLoading={isChangeLoading}
        trendData={trendData}
        isTrendLoading={isTrendLoading}
      />
    </div>
  )

}

export default Card;